import RolesStore from './store/roles.js'


// eslint-disable-next-line no-unused-vars
export function rolesModule({ app, router, store, eventBus }) {

	store.registerModule('roles', RolesStore)

}
